// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__4ZsAW","title":"FAQ_title__mmdvD","item":"FAQ_item__h7yTG"};